import { QueryClient } from "react-query";

const queryConfig = {
    queries: {
        useErrorBoundary: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 6000
    }
}


export const queryClient = new QueryClient({ defaultOptions: queryConfig })

export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;

export const BACKEND_URL = process.env.REACT_APP_API_URL;

export const REACT_APP_CURRENT_TIME_URL = process.env.REACT_APP_CURRENT_TIME_URL;

